import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ValidatingIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7H8V9H6V7ZM6 10H8V12H6V10ZM11 13H9V15H11V13ZM9 10H11V12H9V10ZM17 10H15V12H17V10ZM15 13H17V15H15V13ZM11 16H9V18H11V16ZM12 7H14V9H12V7ZM14 10H12V12H14V10Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { ValidatingIcon };
